import React from 'react'
import PropTypes from 'prop-types'

const CheckboxInputBuilder = ({id, inputValue, inputLabel, inputChecked, onClick}) => (
  <li><label><input type="checkbox" name="do_array" defaultValue={inputValue} checked={inputChecked} onChange={(e) => onClick(e,id)}/> {inputLabel}</label></li>
)
CheckboxInputBuilder.propTypes = {
  id: PropTypes.number.isRequired,
  inputValue: PropTypes.string.isRequired,
  inputLabel: PropTypes.string.isRequired,
  inputChecked: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
}

export default CheckboxInputBuilder

export const DO_ARRAY = [
  { id: 0, inputValue: 'all', inputLabel: '全体', inputChecked:true },
  { id: 1, inputValue: 'news', inputLabel: 'ニュースリリース', inputChecked:false },
  { id: 2, inputValue: 'info', inputLabel: 'お知らせ', inputChecked:false },
]
